import PropTypes from 'prop-types';
import ImageProp from '../../../commonComponents/propTypes/imageProp';

const propType = {
  _id: PropTypes.string,
  name: PropTypes.string,
  price: PropTypes.number,
  promotionPrice: PropTypes.number,
  attributes: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.object),
    PropTypes.arrayOf(PropTypes.string),
  ]),
  stockQuantity: PropTypes.number,
  userPrice: PropTypes.object,
  userPromotionPrice: PropTypes.object,
  icon: PropTypes.shape(ImageProp.propType),
  isPack: PropTypes.bool,
  packVariations: PropTypes.arrayOf(
    PropTypes.shape({
      quantity: PropTypes.number,
      variation: PropTypes.shape({}),
    }),
  ),
};

export default { propType };
